import React, { useEffect } from 'react';
import Lenis from 'lenis';
import Navbar from './components/Navbar/Navbar';
import Hero from './components/Hero/Hero';
import Ticker from './components/Ticker/Ticker';
import AboutVision from './components/AboutVision/AboutVision';
import Categories from './components/Categories/Categories';
import FlashSale from './components/FlashSale/FlashSale';
import Collections from './components/Collections/Collections';
import Gallery from './components/Gallery/Gallery';
import Speciality from './components/Speciality/Speciality';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import FloatingActions from './components/FloatingActions/FloatingActions';
import './App.css';

function App() {
  useEffect(() => {
    // Initialize Lenis smooth scroll
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);

    return () => {
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <Navbar />
      <main>
        <Hero />
        <Ticker />
        <AboutVision />
        <Categories />
        <FlashSale />
        <Collections />
        <Gallery />
        <Speciality />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}

export default App;
